/**
 * 异常记录api
 * date:2022 03 27 fuck
 */
import httpRequest from '@/utils/request.js';

// 获取无效异常规则列表
export const getRuleList = (params) =>
    httpRequest.httpGet({
        url: `/service/ex/rule/list`,
        params
    });
// 删除无效异常规则

// 获取无效异常规则详情
export const getRuleDetail = (id) =>
httpRequest.httpGet({
    url: `/service/ex/rule/${id}`
});

// 保存无效异常规则关联监测点
export const ruleSaveCarrier = (id, data) => 
    httpRequest.httpPost(`/service/ex/rule/${id}/carrier/associate`, data);

// 获取无效异常规则监测点列表
export const getRuleCarrierList = (id, params) =>
httpRequest.httpGet({
    url: `/service/ex/rule/carrier/${id}`,
    params
});

// 新增无效异常规则
export const saveRule = (data) => 
    httpRequest.httpPost(`/service/ex/rule/add`, data);
// 更新无效异常规则
export const updateRule = (data) => 
httpRequest.httpPost(`/service/ex/rule/update`, data);
// 删除无效异常规则
export const ruleDel = (id)  =>
    httpRequest.httpdelete( `/service/ex/rule/delete/${id}`)
// 删除无效异常规则关联的监测点
export const ruleCarrierDel = (ruleId, carrierId)  =>
    httpRequest.httpdelete( `/service/ex/rule/carrier/delete/${ruleId}/${carrierId}`)

// ===== 以下 API 被 ExDetailDia/HandleExDia 等共用组件引用，保留 =====
/**异常处理获取 tab */
export const exTab = (params = {}) =>
    httpRequest.httpGet({
        url: '/service/ex/tab',
        params: {
            ...params
        }
    });
/**异常处理获取设备类型 */
export const getExRecordPage = params =>
    httpRequest.httpGet({
        url: `/service/ex/records`,
        params
    });
// 获取处理记录分页
export const getExHandleRecordPage = params =>
    httpRequest.httpGet({
        url: `/service/ex/process`,
        params
    });
// 标记异常记录
export const markExRecord = (type, id) =>
    httpRequest.httpGet({
        url: `/service/ex/mark/${type}/${id}`
    });

// 异常分页（被 invalidRule 引用）
export const exPage = (params = {}) =>
    httpRequest.httpGet({
        url: '/service/ex/page',
        params: {
            ...params
        }
    });
/**查询异常处理（被 business/Table 引用） */
export const exProcess = (params = {}) =>
    httpRequest.httpGet({
        url: '/service/ex/process',
        params: {
            ...params
        }
    });
/**异常原因（被 AlarmSwitch/AlarmLog/handleCom 引用） */
export const exReasons = (params = {}) =>
    httpRequest.httpGet({
        url: '/service/ex/reasons',
        params: {
            ...params
        }
    });
/**异常处理（被 ExContentDetail 引用） */
export const exHandle = data => httpRequest.httpPost('/service/ex/handle', data);

// 异常记录详细（被 ExDetailDia/ExDetail 引用）
export const exDetail = id =>
    httpRequest.httpGet({
        url: '/service/ex/detail',
        params: {
            id
        }
    });

/**异常列表（被 carrierAbnormal 引用） */
export const exList = (params = {}) =>
    httpRequest.httpGet({
        url: '/service/ex/list',
        params: {
            ...params
        }
    });
/**查询列表-新接口（被 interHtml 引用） */
export const exEecords = (params = {}) =>
    httpRequest.httpGet({
        url: '/service/ex/records',
        params: {
            ...params
        }
    });
/**异常处理数据（被 chaoozeRegion 引用） */
export const exDev = (params = {}) =>
    httpRequest.httpGet({
        url: '/service/ex/dev',
        params: {
            ...params
        }
    });
// 删除异常记录（被 invalidRule 引用）
export const delEx = params => httpRequest.httpdelete2(`/service/ex/delete`, params);

